export default "__VITE_ASSET__BQCe4bnq__"